import axiosInstance from './axiosInstance';

export interface ClarityResponse {
  clarityId: string;
}

export async function getClarityIdAPI(tenantKey: string): Promise<string> {
  const response = await axiosInstance.get<ClarityResponse>(`/Auth/GetClarityId`, {
    params: { tenantKey },
  });
  return response.data.clarityId;
}
